if (!customElements.get("cart-drawer")) {
  customElements.define(
    "cart-drawer",
    class CartDrawer extends Drawer {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);
        document.body.classList.add('cart-drawer-open');

        // Re-query DOM since cart content gets replaced on updates
        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.showContent();
      }

      hide() {
        super.hide();
        document.body.classList.remove('cart-drawer-open');

        const recommendationByHistory = this.querySelector(
          "recommendation-by-history",
        );
        if (recommendationByHistory) recommendationByHistory.abortFetch();
      }
    },
  );
}
